import { ReactNode, useEffect, useState } from 'react';
import { rgba } from 'polished';
import styled from 'styled-components';
import { Form } from 'formik';
import { useTranslation } from 'react-i18next';

import { LanguageSelect } from '@treams/treams-ui';

import Breakpoint from 'packages/kakapo-ui-kit/helpers/Breakpoint';
import Logo from 'packages/kakapo-ui-kit/components/common/Logo';
import CenterHorizontal from 'packages/kakapo-ui-kit/components/atoms/CenterHorizontal';
import StickToSide from 'packages/kakapo-ui-kit/components/atoms/StickToSide';
import LanguageService from 'packages/kakapo-ui-services/services/common/LanguageService';
import { Kakapo2Treams, Treams2Kakapo } from 'packages/kakapo-ui-application/hooks/useLanguage';
import { Box } from 'reflexbox';

interface IProps {
	children: ReactNode;
	empty?: boolean;
}

export const Background = styled.div<{ empty?: boolean }>`
	background-image: url('${(props) => props.theme.images.loginBackground}?d=1920x1080');
	background-size: cover;
	background-position: center;
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;

	${(props) =>
		props.empty &&
		`
	@media screen and (max-width: ${Breakpoint.Small}) {
		display: block;
	}`}
`;

export const Element = styled.div<{ empty?: boolean }>`
	${(props) =>
		props.empty
			? `
		padding: 40px;
		max-width: 660px;
	`
			: `
		padding: 60px 40px 40px 40px;
		max-width: 460px;
		flex: 1;
	`}
	background: white;
	border-radius: 6px;
	box-shadow:
		0px 2px 4px ${(props) => rgba('black', 0.125)},
		0px 8px 16px ${(props) => rgba('black', 0.05)},
		0px 32px 64px ${(props) => rgba('black', 0.125)};
	position: relative;
	margin: 20px 0;

	@media screen and (max-width: ${Breakpoint.Small}) {
		padding: 50px 20px 20px 20px;
		margin: 0;
	}
`;

export default function PublicForm({ children, empty }: IProps) {
	const { i18n } = useTranslation();

	const service = new LanguageService();
	const [currentLanguage, setCurrentLanguage] = useState(service.currentLanguage);

	useEffect(() => {
		service.currentLanguage = currentLanguage;
		i18n.changeLanguage(currentLanguage);
	}, [currentLanguage]);

	return (
		<Background empty={empty}>
			<Element empty={empty}>
				<Form>
					{!empty && (
						<>
							<StickToSide top={10} right={10}>
								<LanguageSelect
									value={Kakapo2Treams[currentLanguage]}
									onChange={(language) => setCurrentLanguage(Treams2Kakapo[language])}
								/>
							</StickToSide>

							<CenterHorizontal>
								<Logo to="/" />
							</CenterHorizontal>
						</>
					)}

					{children}
				</Form>
			</Element>
		</Background>
	);
}
